var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { EquityDropdown, } from "@frameworks/web/components/generic/equitydropdown/equitydropdown";
import { MFSipRegistration } from "../constant";
import InputField from "@frameworks/web/components/generic/inputField";
import di from "../di/serviceLocator";
import { useSelector } from "react-redux";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import EdModal from "../../../../../shared-library/components/edModal";
import ReportValue from "../../../../../shared-library/components/commonTableVal";
import MFRegistrationPopup from "./MFRegistrationPopup";
import Loader from "../../../../../shared-library/components/Loader";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
var MFSIPRegistrationBook = function (props) {
    var columnList = [
        "Account Code",
        "Scheme Name ",
        "SIP Tenure",
        "M/Q ",
        "End Date",
        "SIP Paid",
        "SIP Rejected",
        "Next Due Date",
        "SIP Pending",
        "Amount",
        "Total Investment",
        "Mandate Id",
        "Transactions",
    ];
    var _a = __read(useState(MFSipRegistration[0]), 2), mfSipRegistration = _a[0], setMFSipRegistration = _a[1];
    var _b = __read(React.useState(""), 2), searchText = _b[0], setSearchText = _b[1];
    var _c = __read(React.useState(), 2), searchResultData = _c[0], setSearchResultData = _c[1];
    var _d = __read(React.useState(false), 2), viewTransaction = _d[0], setViewTransaction = _d[1];
    var _e = __read(React.useState(), 2), selectedRecord = _e[0], setSelectedRecord = _e[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    React.useEffect(function () {
        mfRegistrationAPIData("All");
    }, []);
    var mfLoader = useSelector(function (state) { var _a, _b; return (_b = (_a = state.Clients.MFRegistartionBook) === null || _a === void 0 ? void 0 : _a.commonData) === null || _b === void 0 ? void 0 : _b.loader; });
    var getSearchDataFromWithinData = function (searchText) {
        setSearchText(searchText);
        var searchResultData = [];
        if (mfRegistrationData &&
            mfRegistrationData.length > 0 &&
            !!searchText &&
            searchText !== "") {
            mfRegistrationData.map(function (record) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                if (((_a = record.schemeName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchText.toLowerCase())) ||
                    ((_c = (_b = record.acCode) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === null || _c === void 0 ? void 0 : _c.includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_d = record.amount) === null || _d === void 0 ? void 0 : _d.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_e = record === null || record === void 0 ? void 0 : record.sipTenure) === null || _e === void 0 ? void 0 : _e.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_f = record === null || record === void 0 ? void 0 : record.mq) === null || _f === void 0 ? void 0 : _f.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_g = record === null || record === void 0 ? void 0 : record.sipRejected) === null || _g === void 0 ? void 0 : _g.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_h = record === null || record === void 0 ? void 0 : record.spiPaid) === null || _h === void 0 ? void 0 : _h.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_j = record === null || record === void 0 ? void 0 : record.nextDueDate) === null || _j === void 0 ? void 0 : _j.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_k = record === null || record === void 0 ? void 0 : record.spiPaid) === null || _k === void 0 ? void 0 : _k.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_l = record === null || record === void 0 ? void 0 : record.totalInvestment) === null || _l === void 0 ? void 0 : _l.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase()))) {
                    searchResultData.push(record);
                }
            });
        }
        setSearchResultData(searchResultData);
    };
    var mfRegistrationAPIData = function (selectedvalue) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, di.clients.getMFRegistrationBookData({
                        acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                        status: selectedvalue,
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var mfRegistrationData = useSelector(function (state) { var _a, _b; return (_b = (_a = state.Clients.MFRegistartionBook) === null || _a === void 0 ? void 0 : _a.reducersData) === null || _b === void 0 ? void 0 : _b.data; });
    var getIterationCondition = function () {
        var allowTrue = false;
        if (!!searchText &&
            searchText !== "" &&
            searchResultData &&
            (searchResultData === null || searchResultData === void 0 ? void 0 : searchResultData.length) > 0) {
            allowTrue = true;
        }
        else if ((searchText === "" || searchText === undefined || searchText === null) &&
            mfRegistrationData &&
            (mfRegistrationData === null || mfRegistrationData === void 0 ? void 0 : mfRegistrationData.length) > 0) {
            allowTrue = true;
        }
        return allowTrue;
    };
    var getIterationMappedData = function () {
        var data = mfRegistrationData;
        if (searchResultData &&
            !!searchText &&
            searchText !== "" &&
            (searchResultData === null || searchResultData === void 0 ? void 0 : searchResultData.length) > 0) {
            data = searchResultData;
        }
        return data;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mf-registration" },
            React.createElement(Row, null,
                React.createElement(Col, { lg: 12, className: "m-2" },
                    React.createElement("nav", { className: "generic-breadcrumb container p-0 viewall-breadcrumb" },
                        React.createElement("ol", { className: "breadcrumb" },
                            React.createElement("li", { className: "breadcrumb-item EncodeSans_12_500 txt_secondary-gray hand_cursor", onClick: function () { return props === null || props === void 0 ? void 0 : props.closeMf(false); } }, "Reports"),
                            React.createElement("li", { className: "breadcrumb-item EncodeSans_12_500 active hand_cursor" }, "MF SIP Registration Book"))))),
            React.createElement(Row, null,
                React.createElement(Col, { lg: 12, className: "d-flex align-items-center justify-content-end mt-20" },
                    React.createElement("div", null,
                        React.createElement(InputField, { placeholderClassName: "", prefix: React.createElement("i", { className: "edel-icon-search1" }), className: "filter-search ps-2 input-group input-group-with-search filter-serach-gray", placeholder: "Search", defaultValue: searchText, onChangeEvent: function (e) {
                                getSearchDataFromWithinData(e.target.value);
                            } })),
                    React.createElement("div", { className: "d-flex align-items-center mx-3 DMSanM_14_500" },
                        React.createElement("label", null, "Select Status"),
                        React.createElement(EquityDropdown, { itemlist: MFSipRegistration, defaultVal: true, selectedDefaultVal: mfSipRegistration, selectedValue: function (e) {
                                setMFSipRegistration(e);
                                mfRegistrationAPIData(e.value);
                            }, externalClassname: " common-drp-not-brd" })))),
            React.createElement(Row, null,
                React.createElement(Col, { lg: 12, className: "mt-20" },
                    React.createElement(Table, { className: "lead-table service-request mfsipregistration" },
                        React.createElement("thead", { className: "DMSansMedium_12_500 txt_primaryGrey" },
                            React.createElement("tr", null, columnList.map(function (column, idx) {
                                return React.createElement("th", { key: idx }, column);
                            }))),
                        React.createElement("tbody", { className: "DMSanN_14_400 txt_blackOne1" },
                            getIterationCondition()
                                ? getIterationMappedData().map(function (items) {
                                    return (React.createElement("tr", null,
                                        React.createElement("td", null, addDashIfNullOrUndefined(items.acCode)),
                                        React.createElement("td", null,
                                            React.createElement("span", null, addDashIfNullOrUndefined(items === null || items === void 0 ? void 0 : items.schemeName))),
                                        React.createElement("td", null, addDashIfNullOrUndefined(items.sipTenure)),
                                        React.createElement("td", null, addDashIfNullOrUndefined(items.mq)),
                                        React.createElement("td", null, addDashIfNullOrUndefined(items.endDate)),
                                        React.createElement("td", null, addDashIfNullOrUndefined(items.spiPaid)),
                                        React.createElement("td", null, addDashIfNullOrUndefined(items.sipRejected)),
                                        React.createElement("td", null, addDashIfNullOrUndefined(items.nextDueDate)),
                                        React.createElement("td", null, addDashIfNullOrUndefined(items.sipPending)),
                                        React.createElement("td", { className: "RobotoR_14_400" },
                                            React.createElement(ReportValue, { val: items.amount, stream: false, onlyval: false })),
                                        React.createElement("td", { className: "RobotoR_14_400" },
                                            React.createElement(ReportValue, { val: items.totalInvestment, stream: false, onlyval: false })),
                                        React.createElement("td", null, addDashIfNullOrUndefined(items.mandateID)),
                                        React.createElement("td", { className: "hand_cursor", onClick: function () {
                                                setViewTransaction(true);
                                                setSelectedRecord(items);
                                            } }, "View All")));
                                })
                                : !mfLoader && (React.createElement("tr", null,
                                    React.createElement("td", { colSpan: 12, className: "border-0" },
                                        React.createElement(Errormsg, { msg: "No Data Found" })))),
                            mfLoader && (React.createElement("tr", null,
                                React.createElement("td", { colSpan: 12, className: "border-0" },
                                    React.createElement("div", { className: "position-relative client-loader" },
                                        React.createElement(Loader, null)))))))))),
        React.createElement(EdModal, { show: viewTransaction, setShow: setViewTransaction, showFooter: false, modalTitle: "mf-transaction commonmodal sales-client", children: React.createElement(MFRegistrationPopup, { data: selectedRecord }) })));
};
export default MFSIPRegistrationBook;
